import {PageInfo} from './page-info';

export class Page {
  pageInfo: PageInfo;

  constructor(pageName: string, language: string) {
    this.pageInfo = new PageInfo(pageName, language);
  }

  public getPageInfo(): PageInfo {
    return this.pageInfo;
  }
}
